import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getDetailsOfInquiry } from '@api/inquiries';
import { IInquiryDetails } from '@interfaces/inquiries';

export const handleGetInquiryDetails = createAsyncThunk<
  AxiosResponse<IInquiryDetails>,
  { id: number }
>('getInquiryDetails', ({ id }) => getDetailsOfInquiry(id));
